<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div
    id="animate"
    class="modal-dialog">
    <div class="modal-content">
      <div
        class="modal-header"
        style="padding: 0px;">
        <a
          data-dismiss="modal"
          class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
        <div class="p-a">
          <span class="h5 text-capitalize">{{ title }}</span>
        </div>
      </div>
      <div class="modal-body text-center p-lg">
        <multiselect
          id="ajaxStation"
          v-model="label.outlets"
          :options="items"
          :multiple="true"
          :loading="ajaxStationLoading"
          :close-on-select="false"
          :clear-on-select="true"
          :hide-selected="true"
          :allow-empty="true"
          :disabled="!canManageLabel"
          label="name"
          track-by="id"
          placeholder="Type to search"
          @search-change="loadStation"
        >
          <template
            slot="selection"
            slot-scope="{ values, search, isOpen }">
            <span
              v-if="values.length &amp;&amp; !isOpen"
              class="multiselect__single">{{ values.length }} stations selected</span>
          </template>
        </multiselect>

        <div class="table-wrapper-scroll-y my-custom-scrollbar m-t-1">
          <div>
            <table class="table">
              <tbody>
                <tr
                  v-for="station in label.outlets"
                  :key="station.id">
                  <td style="text-align:left;">{{ station.name }}</td>
                  <td class="text-right">
                    <a class="nav-link text-muted m-r-sm">
                      <i
                        class="material-icons md-18"
                        @click="deleteItem(station)">&#xe14c;</i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn primary p-x-md"
          data-dismiss="modal"
          @click="apply_station()">Apply</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</template>

<script>
import reject from 'lodash/reject';
import Auth from '@js/plugins/auth';

export default {
    props: {
        label: {
            type: Object,
            required: true,
        },

        title: {
            type: String,
            required: false,
            default: 'Select stations',
        },
    },

    data() {
        return {
            ajaxLabelLoading: false,
            multiselect_query_limit: 30,
            ajaxStationLoading: false,
            api_item_select: Laroute.route('franchise.vue.outlets'),
            items: [],
            station: [],
            labels: [],
            loading: false,
        };
    },

    computed: {
        canManageLabel() {
            return Auth.hasPermissionTo('franchise_manage_labels');
        },
    },

    mounted() {
        var that = this;
        this.loadStation(null);

        $('#station-popup').on('hidden.bs.modal', function(e) {
            that.errors.clear();
        });
    },

    methods: {
        onSelect(items) {
            this.label.stations = items;
        },

        apply_station() {
            this.$emit('updateStation', this.label.outlets);
        },

        deleteItem(option) {
            this.label.outlets = reject(this.label.outlets, option);
        },

        loadStation: _.debounce(function(query) {
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.ajaxStationLoading = true;
            this.$http.get(this.api_item_select, options).then(response => {
                this.items = response.data.data;
                this.ajaxStationLoading = false;
            });
        }, 500),
    },
};
</script>


<style>
.my-custom-scrollbar {
    position: relative;
    height: 200px;
    overflow: overlay;
}
.table-wrapper-scroll-y {
    display: block;
}
</style>
